var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M11.876 29.684c-.862 0-1.358-.085-1.84-.324l-.131-.069a2.786 2.786 0 01-1.133-1.172c-.274-.531-.369-1.04-.369-1.999v-6.205c0-.96.095-1.468.37-2 .257-.5.644-.901 1.132-1.172.525-.291 1.031-.392 1.97-.392H36.2c.94 0 1.445.1 1.97.392.488.27.875.672 1.133 1.172.274.532.37 1.04.37 2v6.205c0 .96-.096 1.468-.37 2-.258.5-.645.9-1.132 1.171-.526.292-1.032.393-1.971.393l-15.051-.001-.026.097c-.44 1.445-1.713 2.481-3.212 2.565l-.197.006c-1.648 0-3.062-1.152-3.46-2.759l.024.091z", fill: "currentColor", fillRule: "nonzero", stroke: "none", strokeWidth: 1 })));
});
